var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "productExplorer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folder",
    d: "M19,3H12.472a1.019,1.019,0,0,1-.447-.1L8.869,1.316A3.014,3.014,0,0,0,7.528,1H5A5.006,5.006,0,0,0,0,6V18a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V8a5.006,5.006,0,0,0-5-5ZM5,3H7.528a1.019,1.019,0,0,1,.447.1l3.156,1.579A3.014,3.014,0,0,0,12.472,5H19a3,3,0,0,1,2.779,1.882L2,6.994V6A3,3,0,0,1,5,3ZM19,21H5a3,3,0,0,1-3-3V8.994l20-.113V18A3,3,0,0,1,19,21Z",
    transform: "translate(0 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "boxes_1_",
    "data-name": "boxes (1)",
    d: "M8.249,6.768a.423.423,0,0,1-.423.423H6.98a.423.423,0,0,1,0-.846h.846A.423.423,0,0,1,8.249,6.768Zm1.9-.423V8.46A1.694,1.694,0,0,1,8.46,10.152H1.692A1.694,1.694,0,0,1,0,8.46V6.345A1.694,1.694,0,0,1,1.692,4.653h.423V1.692A1.694,1.694,0,0,1,3.807,0H6.345A1.694,1.694,0,0,1,8.037,1.692V4.653H8.46A1.694,1.694,0,0,1,10.152,6.345ZM2.961,4.653h4.23V1.692A.847.847,0,0,0,6.345.846H3.807a.847.847,0,0,0-.846.846ZM1.692,9.306H4.653V5.5H1.692a.847.847,0,0,0-.846.846V8.46A.847.847,0,0,0,1.692,9.306ZM9.306,6.345A.847.847,0,0,0,8.46,5.5H5.5V9.306H8.46a.847.847,0,0,0,.846-.846Zm-6.134,0H2.327a.423.423,0,1,0,0,.846h.846a.423.423,0,1,0,0-.846Zm2.75-4.23A.423.423,0,0,0,5.5,1.692H4.653a.423.423,0,0,0,0,.846H5.5A.423.423,0,0,0,5.922,2.115Z",
    transform: "translate(6.924 8.848)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductExplorer);
export default __webpack_public_path__ + "static/media/productExplorer.eb034c2c49bf2a9410146adb7ac30974.svg";
export { ForwardRef as ReactComponent };